















































































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import BookmarkAddMenu from './bookmark-add-menu.vue'
import BookmarkListMixin from '@/components/bookmark/mixins/bookmark-list-mixin';

@Component({
  components: {
    BookmarkAddMenu
  }
})
export default class BookmarkList extends mixins(BookmarkListMixin) {
  @Prop({ default: '' })
  contentClass: string;

  @Prop() 
  nudgeLeft: number;

  @Prop() 
  nudgeRight: number;

  @Prop() 
  nudgeTop: number;

  @Prop() 
  nudgeBottom: number;

  @Prop()
  offsetX: boolean; 

  @Prop()
  offsetY: boolean;
  
  @Prop()
  left: boolean;

  menu: boolean = false;
  search: string = '';

  get pContentClass() {
    let result = [ 'bookmark-list__menu' ];

    if(this.contentClass) {
      result.push(this.contentClass);
    }

    return result.join(' ');
  }

  close() {
    this.menu = false;
  }

  get bookmarksFiltered() {
    const search = this.search.toLowerCase();

    return this.bookmarks
      .filter((item) => item.titleLowerCase.includes(search));
  }
}
